module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/179-ireland-aa7ce2df5dcb250c647ae8c342fb3831.svg";